import React, { FC } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { IconTrash } from '../../../utils/icons';

interface Props {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

// Generic destructive-action confirmation used across the expert-matching
// admin pages (product categories, attributes, attribute options).
export const ConfirmDialog: FC<Props> = ({
  open,
  title,
  message,
  confirmLabel = 'Delete',
  loading = false,
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
    <DialogTitle>
      <Typography fontFamily="CircularStdBlack" sx={{ fontSize: 20 }}>
        {title}
      </Typography>
    </DialogTitle>
    <DialogContent>
      <Typography color="var(--text-2)">{message}</Typography>
    </DialogContent>
    <DialogActions sx={{ p: 2, gap: 1.5 }}>
      <Button variant="outlined" onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={onConfirm}
        disabled={loading}
        startIcon={<IconTrash width={18} height={18} stroke="#fff" />}
      >
        {loading ? 'Deleting…' : confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);
